import { render, staticRenderFns } from "./AcademyCardTestimonial.vue?vue&type=template&id=3a865bc2&scoped=true&"
import script from "./AcademyCardTestimonial.vue?vue&type=script&lang=ts&"
export * from "./AcademyCardTestimonial.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyCardTestimonial.vue?vue&type=style&index=0&id=3a865bc2&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a865bc2",
  null
  
)

export default component.exports